
(function (window, document, jQuery, undefined) {
    var $ = jQuery.noConflict();
    var $btn = $(".don-acc-search__btn").first();
    var $input = $(".don-acc-search__form-control").first();
    var $items = $(".kit-accordeon-widget__item");

    function SearchAccordeons(expression) {
        $.each($items, function ToggleItem(index) {
            $item = $($items[index]);
            
            var hasExpression = $item
                .find(".kit-accordeon-widget__card-body:contains(" + expression + ")")
                .length;
            if (!hasExpression) {
                $item.hide();
            }
            else {
                $item.show();
            }
        });
    }

    $btn.click(function SearchAccordeonClicked(e) {
        e.preventDefault();
        SearchAccordeons($input.val());
    });
})(window, document, jQuery);
